module.exports = __webpack_public_path__ + "img/billtrust-logo.bea9878b.png";